/**
 * Copyright (c) 2015-present, Alibaba Group Holding Limited.
 * All rights reserved.
 *
 * @providesModule ReactActivityIndicator
 */
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ReactView = require('ReactView');

var _ReactView2 = _interopRequireDefault(_ReactView);

var _ReactStyleSheet = require('ReactStyleSheet');

var _ReactStyleSheet2 = _interopRequireDefault(_ReactStyleSheet);

var _domkitAppendVendorPrefix = require('domkit/appendVendorPrefix');

var _domkitAppendVendorPrefix2 = _interopRequireDefault(_domkitAppendVendorPrefix);

var _domkitInsertKeyframesRule = require('domkit/insertKeyframesRule');

var _domkitInsertKeyframesRule2 = _interopRequireDefault(_domkitInsertKeyframesRule);

var keyframes = {
  '50%': {
    opacity: 0.3
  },
  '100%': {
    opacity: 1
  }
};

var GRAY = '#999999';

var animationName = (0, _domkitInsertKeyframesRule2['default'])(keyframes);

var ActivityIndicator = _react2['default'].createClass({
  displayName: 'ActivityIndicator',

  propTypes: {
    /**
     * Whether to show the indicator (true, the default) or hide it (false).
     */
    animating: _react.PropTypes.bool,
    /**
     * The foreground color of the spinner (default is gray).
     */
    color: _react.PropTypes.string,
    /**
     * Size of the indicator. Small has a height of 20, large has a height of 36.
     */
    size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      animating: true,
      color: GRAY,
      size: 'small'
    };
  },

  render: function render() {

    // size
    var sizeContainerClass = this.props.size === 'large' ? "win-ring win-large" : "win-ring win-small";

    // hidden
    if (this.props.animating === false) {
      return null;
    };

    return _react2['default'].createElement('progress', { /*id="progressRing"*/
      className: sizeContainerClass,
      style: _extends({}, this.props.style, {
        color: this.props.color
      }) });
  }
});

var styles = _ReactStyleSheet2['default'].create({
  container: {
    position: 'relative',
    fontSize: 0,
    alignItems: 'center',
    justifyContent: 'center'
  },
  sizeSmallContainer: {
    width: 20,
    height: 20
  },
  sizeLargeContainer: {
    width: 36,
    height: 36
  },
  sizeSmallLine: {
    width: 2,
    height: 5,
    borderRadius: 2
  },
  sizeLargeLine: {
    width: 3,
    height: 9,
    borderRadius: 3
  }
});

module.exports = ActivityIndicator;


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/lib/ActivityIndicator/ActivityIndicator.winjs.js
 **/